<template>
  <div
   v-if="loadingState"
   key="loadingState"
   >
   <AtomLoadingSecondary/>
 </div>
 <div v-else>
  <div class="m-edition-billing-academy-clients-sales display-flex-row padding-left-zero">
    <div class="m-edition-billing-academy-clients-sales-content">
      <span class="margin-left-zero">
        <p class="font-weight-bold">{{  $t('mEditionBillingAcademyClientsSales.content.academy') }}</p>
        <p> {{ this.academia.nombre }} </p>
      </span>
      <span>
        <p class="font-weight-bold">{{  $t('mEditionBillingAcademyClientsSales.content.name') }}</p>
        <p> {{ this.data.cliente.razon_social }} </p>
      </span>
      <span>
        <p class="font-weight-bold">{{  $t('mEditionBillingAcademyClientsSales.content.eur') }}</p>
        <p> {{ getMonto('EUR') }} </p>
      </span>
      <span>
        <p class="font-weight-bold">{{  $t('mEditionBillingAcademyClientsSales.content.usd') }}</p>
        <p> {{ getMonto('USD') }} </p>
      </span>
      <span>
        <p class="font-weight-bold">{{  $t('mEditionBillingAcademyClientsSales.content.ars') }}</p>
        <p> {{ getMonto('ARS') }} </p>
      </span>
      <span>
        <p class="font-weight-bold">{{  $t('mEditionBillingAcademyClientsSales.content.mxn') }}</p>
        <p> {{ getMonto('MXN') }} </p>
      </span>
      <span>
        <p class="font-weight-bold">{{  $t('mEditionBillingAcademyClientsSales.content.lastPayment') }}</p>
        <p> {{ $moment.parseZone(this.data.cliente.ultimo_pago).format('D MMM YYYY') }} </p>
      </span>
      <span>
        <p class="font-weight-bold">{{  $t('mEditionBillingAcademyClientsSales.content.products') }}</p>
        <p> {{ this.data.cliente.cant_productos }} </p>
      </span>
    </div>
    <div class="display-flex-row margin-left-auto">
      <form
        autocomplete="off"
        class="m-form-row"
        name="download-csv-form"
        @submit.prevent="readVentasExportar"
      >
        <AtomButtonPrimary
          :button-primary="buttonPrimary"
          :disabled="pagination.showLoadingState || !ventas.length"
        />
      </form>
    </div>
  </div>
  <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="ventas.length">
          <th
            class="text-align-right"
            width="15%"
          >
            {{ $t('mEditionBillingAcademyClientsSales.table.thTotal') }}
          </th>
          <th
            class="text-align-center"
            width="13%"
          >
             {{ $t('mEditionBillingAcademyClientsSales.table.thDate') }}
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
             {{ $t('mEditionBillingAcademyClientsSales.table.thDiscount') }}
          </th>
          <th
            class="text-align-center"
            width="13%"
          >
             {{ $t('mEditionBillingAcademyClientsSales.table.thMethod') }}
          </th>
          <th
            class="text-align-left"
            width="14%"
          >
             {{ $t('mEditionBillingAcademyClientsSales.table.thConcept') }}
          </th>
          <th
            class="text-align-left"
            width="16%"
          >
             {{ $t('mEditionBillingAcademyClientsSales.table.thClient') }}
          </th>
          <th
            class="text-align-center"
            width="11%"
          >
             {{ $t('mEditionBillingAcademyClientsSales.table.thToPay') }}
          </th>
          <th
            class="text-align-center"
            width="8%"
          >
             {{ $t('mEditionBillingAcademyClientsSales.table.thRecord') }}
          </th>
        </tr>
        <tr
          v-for="(venta, index) in ventas"
          :key="index"
          class="row-data"
        >
          <td class="text-align-right text-white-space-nowrap">
            <a
              v-if="venta.total || venta.precio"
              class="sale-state"
              :href="`${$t('mEditionMenu.billing.academySales.subject')}/${venta.id_venta}/${$t('mEditionMenu.billing.academySales.children.record.subedition')}`"
              target="_blank"
            >
              <span>{{ venta.divisa }} {{ venta.total.toFixed(2) }}</span>
              <span class="text-color-black-35"> {{ venta.divisa_iso_code }}</span><br>
              <small :class="$filters.getSaleStateValue(venta.venta_estado, 'class')">
                {{ $filters.getSaleStateValue(venta.venta_estado, 'name') }}
              </small>
            </a>
            <a
             v-else
              class="sale-state"
              :href="`${$t('mEditionMenu.billing.academySales.subject')}/${venta.id_venta}/${$t('mEditionMenu.billing.academySales.children.record.subedition')}`"
              target="_blank"
            >
              <span>{{ $t('mEditionBillingAcademyClientsSales.free') }}</span><br>
              <small :class="$filters.getSaleStateValue(venta.venta_estado, 'class')">
                {{ $filters.getSaleStateValue(venta.venta_estado, 'name') }}
              </small>
            </a>
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ $moment.parseZone(venta.fecha_venta).format('D MMM YYYY') }}
          </td>
          <td class="ellipsis text-align-center">
            <span
              v-if="venta.cupon_codigo"
              :key="`${index}-${venta.cupon_codigo}`"
            >
              {{ venta.cupon_codigo }}
            </span>
            <span
              v-else
              :key="`${index}-nodiscount`"
            >
              -
            </span>
          </td>
          <td class="text-align-center">
            <span v-if="venta.medio_pago">
              {{ venta.medio_pago }}
            </span>
            <span v-else>
              -
            </span>
          </td>
          <td class="break-word text-align-left">
            {{ venta.concepto }}
          </td>
          <td class="break-word text-align-left">
            <span class="display-flex-column">
              <span>{{ venta.nombre_cliente }}</span>
              <small class="ellipsis font-weight-regular text-color-black-35">
                {{ venta.email_cliente }}
              </small>
            </span>
          </td>
          <td class="text-align-center">
            {{
              venta.total || venta.precio
                ? $utils.getPaymentFrequency(venta.pago_cuotas, venta.pago_frecuencia, venta.pago_intervalo)
                : '-'
            }}
          </td>
          <td class="text-align-center" width="8%">
            <a
              :href="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.academySales.subject')}/${venta.id_venta}/${$t('mEditionMenu.billing.academySales.children.record.subedition')}`"
              class="a-button-no-border a-button-secondary a-button-billing-secondary a-button-icon-rounded align-items-center justify-content-center"
              target="_blank"
            >
              <i class="far fa-file-alt"></i>
            </a>
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
 </div>
</template>
<script>
export default {
  name: 'MoleculeEditionBillingAcademyClientsSales',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      academia: {},

      buttonPrimary: {
        action: this.$t('mEditionBillingAcademyClientsSales.buttonPrimary'),
        behavior: 'download',
        class: 'a-button-primary a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      data: {},

      filter: {
        url_academia: '',
        buscar: '',
        limite: 10,
        pagina: 1
      },

      loadingState: false,

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 1,
        totalQuantity: 0
      },

      ventas: []
    }
  },

  created () {
    this.data = JSON.parse(localStorage.getItem('dataKey'))
    this.filter.url_academia = this.data.academia
    this.filter.buscar = this.data.cliente.email
    this.readAcademia()
  },

  methods: {
    getMonto (divisa) {
      const pago = this.data.cliente.pagos_totales.find((pago) => pago.iso_code === divisa)
      return pago ? `${pago.simbolo} ${pago.monto_total}` : '-'
    },

    readAcademia () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.loadingState = true
        this.$services.read('academia', 'readAcademiaUrl', {}, [this.data.academia])
          .then(response => {
            this.academia = response.data
            this.readVentas()
          })
          .catch(error => {
            this.loadingState = false
            this.pagination.showLoadingState = false
            this.$alerts.pushAlert('mEditionBillingAcademyClientsSales', 'readAcademy', 'error', 'a-alert-danger')
            console.log(error)
          })
      }
    },
    readVentas () {
      this.$services.read('ventas', 'readVentasAcademia', {}, [this.academia.id], this.filter)
        .then(response => {
          this.ventas = []
          this.ventas = response.data.ventas
          this.pagination.currentQuantity = this.ventas.length
          this.pagination.totalPages = response.data.pages
          this.pagination.totalQuantity = response.data.total
          this.pagination.showLoadingState = false
          this.loadingState = false
        })
        .catch(error => {
          console.log(error)
          this.ventas = []
          this.pagination.currentQuantity = 0
          this.pagination.totalPages = 0
          this.pagination.totalQuantity = 0
          this.pagination.showLoadingState = false
          this.loadingState = false
        })
    },

    readVentasExportar () {
      this.$services.read('ventas', 'readVentasAcademiaExportar', {}, [this.academia.id], this.filter)
        .then(response => {
          this.$files.downloadCsv(response.data, `${this.$t('mEditionBillingAcademyClientsSales.files.sales')}-${this.$moment().format('YYYYMMDD')}`)
          this.buttonPrimary.sending = false
          this.$alerts.pushAlert('mEditionBillingAcademyClientsSales', 'readVentasExportar', 'success')
        })
        .catch(error => {
          console.log(error)
          this.buttonPrimary.sending = false
          this.$alerts.pushAlert('mEditionBillingAcademyClientsSales', 'readVentasExportar', 'error', 'a-alert-danger')
        })
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readAcademia()
    }
  }
}
</script>
